<script>
  import Menu from './Menu.svelte';
</script>

<Menu />

<div id="main" class="wrapper style1">
  <div class="container">
    <section id="content">

      <h2>404 - not found!</h2>
      <p>Oops, questa sezione non esiste!</p>
      
    </section>
  </div>
</div>
